import { createContext, useContext } from 'react';

import { AvailableMetric, Treatment } from '../types';

export type EditorDataContextValue = {
  availableMetrics: AvailableMetric[];
  treatments: Treatment[];
};

const EditorDataContext = createContext<EditorDataContextValue>({
  availableMetrics: [],
  treatments: [],
});

export const EditorDataProvider = EditorDataContext.Provider;

export const useEditorData = () => useContext(EditorDataContext);
